import React, { Component } from 'react';
import './TileContainer.css';
import { Filter } from './Filter';
import { Tile } from './Tile';
import _ from 'lodash';
import projects from '../projects.json';

export class TileContainer extends Component {
    constructor() {
        super();
        this.projects = _.sortBy(projects, ['name']);
        this.state = {
            visibleProjects: this.projects,
            showFilter: false
        };
    }
    render() {
        return (
            <div className="tile-container content-container">
                <div className="center-content">
                    <div className="tile-container-title-bar">
                        <h2>Available Efforts</h2>
                        <div
                            className="filter-button secondary-cta"
                            onClick={() => this.setState({ showFilter: true })}>
                            <div className="icon"></div>
                            <p>Filters</p>
                        </div>
                    </div>
                    <div className="all-body-content">
                        <Filter
                            isVisible={this.state.showFilter}
                            closeFilter={() => this.setState({showFilter: false})}
                            onChange={(values) => this.applyFilter(values)}
                            availableLanguages={this.prepareAvailableFilterOptions(_.map(projects, (item) => {
                                return item.tags.languages;
                            }))}
                            availableTechnology={this.prepareAvailableFilterOptions(_.map(projects, (item) => {
                                return item.tags.technology;
                            }))}
                        />
                        <div className="info-tile-container">
                            {this.buildTiles()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    buildTiles() {
        const tiles = [];
        this.state.visibleProjects.forEach((item, idx) => {
            tiles.push(<Tile
                key={idx}
                name={item.name}
                description={item.description}
                source_url={item.links.source_url}
                documentation_url={item.links.documentation_url}
            />);
        });
        if (tiles.length) {
            return tiles;
        } else {
            return (<div>No projects found.</div>);
        }

    }
    applyFilter(values) {
        // if no filters are applied, return all projects
        if (values.languages.length === 0 && values.technology.length === 0) {
            this.setState({
                visibleProjects: this.projects
            });
            return;
        }
        const matchedProjects = _.filter(this.projects, (project) => {

            return (values.languages.length > 0 && _.intersectionBy(project.tags.languages, values.languages, _.toLower).length > 0) || // languages matches
                (values.technology.length > 0 && _.intersectionBy(project.tags.technology, values.technology, _.toLower).length > 0); // technology matches
        });
        this.setState({
            visibleProjects: matchedProjects
        });
    }
    prepareAvailableFilterOptions(items) {
        return _.sortedUniq(_.map(_.flatten(items), (item) => {
            return item;
        }));
    }
    handleSearch(term) {
        const matchedProjects = _.filter(this.projects, (project) => {
            // create an array of all fields we want to include in the search
            const searchComponents = _.flattenDeep([project.name, project.description, _.flatten(project.tags.languages), _.flatten(project.tags.technology)]);
            // if term exists in string, display it
            return searchComponents.join(' ').toLowerCase().indexOf(term.toLowerCase()) > -1;
        });
        this.setState({
            visibleProjects: matchedProjects
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/TileContainer.js